import { render, staticRenderFns } from "./upDrug.vue?vue&type=template&id=3118ab53&scoped=true&"
import script from "./upDrug.vue?vue&type=script&lang=js&"
export * from "./upDrug.vue?vue&type=script&lang=js&"
import style0 from "./upDrug.vue?vue&type=style&index=0&id=3118ab53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3118ab53",
  null
  
)

export default component.exports